module.exports = __webpack_public_path__ + "img/logo.4720ba93.png";